import { QUERY_PARAM_PARENT_PRODUCT } from '@canvas/constants/query-params';

/**
 * Gets search params that are used for embedded mode (EAP)
 * @returns containerAri search params
 */
export const getEmbedSearchParams = () => {
  // Adding a fallback here to satisfy unit tests where jsdom hasn't been set up yet
  const href = globalThis.location?.href ?? 'ws://.';
  const url = new URL(href);

  const containerAri = url.searchParams.get('containerAri');
  const parentProduct = url.searchParams.get(QUERY_PARAM_PARENT_PRODUCT);

  return { containerAri, parentProduct };
};
